import { Asset } from 'app-lib/assetUtils'
import { DEX } from 'app-lib/dexSelector/types'
import { ProviderType } from 'bzx-common/src/domain/ProviderTypeDictionary'
import { BigNumber } from '@0x/utils'
import { getBaseQuote, IChainConfig, udfFeeds } from './chainCommon'

const assets = [Asset.MATIC, Asset.WETH, Asset.WBTC, Asset.USDC, Asset.USDT, Asset.LINK]

const tradePairs: [Asset, Asset][] = [
  [Asset.MATIC, Asset.USDT],
  [Asset.MATIC, Asset.USDC],
  [Asset.WETH, Asset.USDT],
  [Asset.WETH, Asset.USDC],
  [Asset.WBTC, Asset.USDT],
  [Asset.WBTC, Asset.USDC],
  [Asset.USDC, Asset.USDT],
  [Asset.LINK, Asset.USDT],
  [Asset.LINK, Asset.USDC],
]

// add iTokens as collateral
const collateralAssets: Asset[] = assets.concat(assets.map((asset) => ('I' + asset) as Asset))
collateralAssets.push(Asset.STMATIC)

const config: IChainConfig = {
  chainDetails: {
    chainId: 137,
    blockExplorer: 'https://polygonscan.com',
    chainName: 'Polygon Mainnet',
    shortName: 'Polygon',
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18,
    },
    rpcUrls: [
      'https://polygon-rpc.com',
      'https://rpc-mainnet.maticvigil.com',
      'https://rpc-mainnet.matic.quiknode.pro',
    ],
    blocksPerYear: (60 * 60 * 24 * 365) / 15,
  },
  borrowing: { assets, collateralAssets },
  comingSoon: {
    tokens: {},
  },
  contracts: {
    bzx: '0x059D60a9CEfBc70b9Ea9FFBb9a041581B1dFA6a8',
    helperProxy: '0xdb2800b894FDa88F6c49c38379398b257062dF80',
    priceFeed: '0xDB0f02A68e5b52A853d01c5e1d935645FF5c01D4',
    sweepFees: '0x8c02eDeE0c759df83e31861d11E6918Dd93427d2',
    tokenRegistry: '0x4B234781Af34E9fD756C27a47675cbba19DC8765',
  },
  dexes: [DEX.SUSHI, DEX.UNISWAPV3],
  dexesDetails: {
    [DEX.SUSHI]: {
      id: 1,
      address: '0x3D87106A93F56ceE890769A808Af62Abc67ECBD3',
    },
    [DEX.UNISWAPV3]: {
      id: 2,
      address: '0x3d41a177F3cd7907f8f8fFaeb136428B69C585Eb',
    },
  },
  features: { dexSelector: true },
  gas: {
    priceDefault: new BigNumber(5).times(10 ** 9),
    amount: { coefficient: 2, fallback: 450000 },
  },
  lending: { assets },
  protocol: { version: 4 },
  trading: {
    defaultPair: { baseToken: Asset.WETH, quoteToken: Asset.USDT },
    pairs: tradePairs,
    baseQuote: getBaseQuote(tradePairs),
    pairConfigs: {},
  },
  native: { asset: Asset.MATIC, wrapped: Asset.WMATIC },
  nativeTokenSupported: true,
  compromisedContracts: [
    '0xfe4F0eb0A1Ad109185c9AaDE64C48ff8e928e54B', // bzx
    '0xCc0fD6AA1F92e18D103A7294238Fdf558008725a', // helper
    '0x57c7FABb080af5933BfaB2d9ad37374f832A41Bd', // dappHelper
    '0xf326b42a237086f1de4e7d68f2d2456fc787bc01', // iETH
    '0x500c3877650c6c08a59d425d27441eae847ecfda', // iLINK
    '0x949cc03e43c24a954baa963a00bfc5ab146c6ce7', // iMATIC
    '0x2e1a74a16e3a9f8e3d825902ab9fb87c606cb13f', // iUSDC
    '0x18d755c981a550b0b8919f1de2cdf882f489c155', // iUSDT
    '0x97ebf27d40d306ad00bb2922e02c58264b295a95', // iWBTC
    '0xf009c28b2d9e13886105714b895f013e2e43ee12', // iAAVE
    '0x97dfbef4ed5a7f63781472dbc69ab8e5d7357cb9', // iBZRX
  ],
  icon: { name: 'polygon-logo', color: '#863FF8' },
  chartUDF: udfFeeds.BINANCE,
  rpcUrlDefault: process.env.RPC_URL_POLYGON,
  stableCoins: [Asset.USDC, Asset.USDT],
  stablecoinForUsdRates: Asset.USDC,
  stats: { assets },
  twitterHandle: '@0xPolygon',
  uiDisabled: false,
  uiDisabledReason: '',
  wallets: [
    ProviderType.MetaMask,
    ProviderType.TrustWallet,
    ProviderType.WalletConnect,
    ProviderType.WalletLink,
  ],
  uniRouteSettings: {},
}

export default config
